import React, {useEffect, useState} from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  TextField,
  Typography
} from '@material-ui/core';
import {useGoVehisService} from "../../utils/axios";

const emptyForm = {
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
  nip: '',
  sourceUrl: '',
  source: '',
  telemarketingConsent: false,
  electronicConsent: false,
  newsletterConsent: false
};

const ContactAgreementDialog = ({isOpen = false, onClose, agreement = null, onSave}) => {
  const service = useGoVehisService();
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState('');

  const isEdit = agreement !== null;

  useEffect(() => {
    if (isOpen) {
      setForm(agreement ? {...agreement} : emptyForm);
      setError('');
    }
  }, [isOpen, agreement]);

  const handleChange = (e) => {
    const {name, value, type, checked} = e.target;
    setForm(prev => ({...prev, [name]: type === 'checkbox' ? checked : value}));
  };

  const handleSave = async () => {
    setError('');
    try {
      if (isEdit) {
        await service.put(`/admin/contact-agreements/${encodeURIComponent(agreement.email)}`, form);
      } else {
        await service.post('/admin/contact-agreements', form);
      }
      if (onSave) onSave();
      onClose();
    } catch (err) {
      if (err.response && err.response.status === 409) {
        setError(err.response.data || 'Email już istnieje w bazie.');
      } else if (err.response && err.response.data) {
        setError(err.response.data);
      } else {
        setError('Wystąpił błąd. Spróbuj ponownie.');
      }
    }
  };

  return (
    <Dialog onClose={onClose} open={isOpen} maxWidth="sm" fullWidth>
      <DialogTitle>{isEdit ? 'Edytuj zgodę' : 'Dodaj zgodę'}</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Email"
              name="email"
              value={form.email}
              onChange={handleChange}
              fullWidth
              variant="outlined"
              disabled={isEdit}
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Imię"
              name="firstName"
              value={form.firstName}
              onChange={handleChange}
              fullWidth
              variant="outlined"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Nazwisko"
              name="lastName"
              value={form.lastName}
              onChange={handleChange}
              fullWidth
              variant="outlined"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Telefon"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              fullWidth
              variant="outlined"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="NIP"
              name="nip"
              value={form.nip}
              onChange={handleChange}
              fullWidth
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="URL źródła"
              name="sourceUrl"
              value={form.sourceUrl}
              onChange={handleChange}
              fullWidth
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Źródło"
              name="source"
              value={form.source}
              onChange={handleChange}
              fullWidth
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox checked={form.telemarketingConsent} onChange={handleChange} name="telemarketingConsent" color="primary" />}
              label="Zgoda telemarketingowa"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox checked={form.electronicConsent} onChange={handleChange} name="electronicConsent" color="primary" />}
              label="Zgoda elektroniczna"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox checked={form.newsletterConsent} onChange={handleChange} name="newsletterConsent" color="primary" />}
              label="Zgoda newsletter"
            />
          </Grid>
          {error && (
            <Grid item xs={12}>
              <Typography color="error">{error}</Typography>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">Anuluj</Button>
        <Button onClick={handleSave} color="primary" variant="contained">Zapisz</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactAgreementDialog;
